<template>
  <div class="ban">
    <el-dialog
      :visible.sync="defaVisible"
      :close-on-click-modal="false"
      :before-close="clearEdit"
      width="600px"
      title="Edit setting"
    >
      <el-form class="roe" :model="comdataList.ruleForm" :rules="rules2" ref="FourForm" @submit.native.prevent>
        <el-form-item style="display: inline-block; width:600px">
          <p>Whether to allow system to make the optimal choice when the shipping preference is not applicable.</p>
          <el-radio-group v-model="comdataList.ruleForm.efc_id" style="width:100%">
            <el-radio :label="62">Fast</el-radio>
            <el-radio :label="63">Standard</el-radio>
            <el-radio :label="64">Economlcal</el-radio>
            <el-radio :label="65">Classified as pending</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item style="display: inline-block; width:300px">
          <p>Whether to classify orders with freight exceed a certain amount as pending?</p>
          <el-radio-group
            v-model="comdataList.ruleForm.efr_create_date"
            style="width:300px"
            @change="resource"
          >
            <el-radio :label="1">Not</el-radio>
            <el-radio :label="2">Yes, exceed</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item
          style="display: inline-block; width:200px"
          prop="efr_last_update"
          v-if="comdataList.ruleForm.efr_create_date==2"
        >
          <el-input
            type="efr_last_update"
            v-model="comdataList.ruleForm.efr_last_update"
            style="width:200px"
          >
            <template slot="append">CNY</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center;">
        <el-button
          style="background:#8989ba;color:#fff;outline: none;margin-top: 10px;"
          @click="Submit('FourForm')"
        >Confirm</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addrule
} from "../api/setting";
export default {
  props: ["comdataList", "rolesList", "visible"],

  data() {
    return {
      defaVisible: false,
      FourForm: {},
      rules2: {
        efr_last_update: [
          {
            required: true,
            message: "Please enter preference name",
            trigger: "blur"
          }
        ]
      }
    };
  },
  watch: {
    visible(val) {
      this.defaVisible = val;
    }
  },
  methods: {
    clearEdit() {
      this.defaVisible = false;
      //this.form=this.lids
      this.$emit("cleardefa");
    },
    resource() {
      console.log(this.comdataList);
    },
    Submit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          console.log(this.comdataList.ruleForm);
          let opsku = [];
          opsku.push(this.comdataList.ruleForm.skueparated);
          let lte = [];
           let gte = [];
          if(this.comdataList.ruleForm.efr_create_date==2){
             lte.push("0");
             gte.push(this.comdataList.ruleForm.efr_last_update);
          }
          let w_lte = [];
          let w_gte = [];
          let efcValue = "";
          let efcId = "";
          if (
            this.comdataList.ruleForm.efc_id == 62 ||
            this.comdataList.ruleForm.efc_id == 63 ||
            this.comdataList.ruleForm.efc_id == 64
          ) {
            efcValue = 4;
            efcId = this.comdataList.ruleForm.efc_id;
          } else {
            efcValue = 2;
            efcId = 62;
          }

          let param = {
            active: 1,
            ruleStatus: 2,
            ruleClass: this.comdataList.ruleForm.efr_class,
            ruleWarehouse: 4,
            ruleShipPart: "CFF",
            efcId: efcId,
            efcValue: efcValue,
            opsku_type: 0,
            ruleName: this.comdataList.ruleForm.efr_name,
            lte: lte,
            gte: gte,
            w_lte: w_lte,
            w_gte: w_gte,
            rid: this.comdataList.ruleForm.efr_id
          };
          
          if (this.comdataList.ruleForm.lte != "") {
            param.rd_sums = 1;
          }
          console.log(param);
          // let param = {
          //   active:1,
          //   ruleStatus: 2,
          //   ruleClass: this.ThreeForm.priority,
          //   ruleWarehouse: 4,
          //   ruleShipPart: "CFF",
          //   efcId: this.ThreeForm.resource,
          //   efcValue: efcValue,
          //   opsku_type: 0,
          //   ruleName: this.ThreeForm.entername,
          //   rd_opsku: 1,
          //   opsku: opsku,
          //   lte: lte,
          //   gte: gte,
          //   w_lte: w_lte,
          //   w_gte: w_gte,
          //   country: this.ruleForm.countrys,
          //   rd_country: this.ruleForm.countrys.length,
          //   rd_account: this.ruleForm.accounts.length,
          //   account: this.ruleForm.accounts
          // };
          addrule(param)
            .then(response => {
              console.log(response);
              if (response.data.ask == 1) {
                this.$emit("cleardefa");
                this.$parent.handleCurrentChange(1);
                this.defaVisible = false;
              }
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    }
  }
};
</script>

<style scoped>
.ban {
  margin: 20px;
  padding: 20px;
  text-align: left;
}
.ban .ban1 {
  height: 80px;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 70%;
}
.ban1 p {
  padding: 10px;
}
.box-card {
  text-align: left;
}
ul,
li {
  list-style: none;
}
.ban2 {
  width: 900px;
  margin: 0 auto;
  padding: 10px;
  background: #fff;
  text-align: left;
}
.l_tree {
  width: calc(80% - 44px);
  height: 100%;
  padding-left: 42px;
  position: relative;
  margin: 0 auto;
}
ul.l_tree:before {
  content: "";
  border-left: 1px solid #eee;
  height: calc(100%);
  position: absolute;
  left: 10px;
  top: 35px;
}
.l_tree .l_tree_branch:last-child::before {
  content: "";
  width: 3px;
  height: calc(100% - 0px);
  display: block;
  background-color: #ffffff;
  position: absolute;
  bottom: -36px;
  left: -34px;
}
.l_tree_branch::after {
  content: "";
  width: 40px;
  height: 0;
  border-bottom: 1px solid #eee;
  position: absolute;
  right: calc(100% - 9px);
  top: 35px;
}
.l_tree_branch {
  width: 100%;
  height: 100%;
  display: block;
  padding: 13px;
  position: relative;
}
</style>





// WEBPACK FOOTER //
// src/components/views/Setting/defaultset.vue